var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash-es';
import { ConfirmationService, TermService, AuthService } from '../services';
import { PAGES } from './nav';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
var ShellLayoutComponent = /** @class */ (function () {
    function ShellLayoutComponent(confirmationService, router, activatedRoute, termService, authService) {
        this.confirmationService = confirmationService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.termService = termService;
        this.authService = authService;
        this.mylinks = [];
        this.pageData = {};
    }
    ShellLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        //  sending the resize event, for AdminLTE to place the height
        var ie = this.detectIE();
        if (!ie) {
            window.dispatchEvent(new Event('resize'));
        }
        else {
            // solution for IE from @hakonamatata
            var event_1 = document.createEvent('Event');
            event_1.initEvent('resize', false, true);
            window.dispatchEvent(event_1);
        }
        // build the links array
        this.mylinks = [];
        _.forEach(PAGES, function (page) {
            if (page.sidebar) {
                if (page.path) {
                    page.link = ['/' + page.path];
                }
                _this.mylinks.push(page);
            }
        });
        // Batch jobs link only for NEXEDUSUPER
        var user = this.authService.getCurrentUser();
        if (user && user._id === 'NEXEDUSUPER') {
            var batchJobsPage = __assign(__assign({}, PAGES.batchJobs), { link: ['/' + PAGES.batchJobs.path] });
            this.mylinks.push(batchJobsPage);
        }
        // based on https://toddmotto.com/dynamic-page-titles-angular-2-router-events
        this.router.events
            .filter(function (event) { return event instanceof NavigationEnd; })
            .map(function () { return _this.activatedRoute; })
            .map(function (route) {
            while (route.firstChild)
                route = route.firstChild;
            return route;
        })
            .filter(function (route) { return route.outlet === 'primary'; })
            .mergeMap(function (route) { return route.data; })
            .subscribe(function (event) {
            _this.pageData = event;
        });
        this.stageSubscription = this.authService.subscribeToStage(function (data) {
            if (data && !data.initial) {
                _this.router.navigate(['/']);
            }
        });
        var term = this.authService.getSelectedTerm();
        if (term) {
            this.termService.getSchoolStructure(term._id)
                .subscribe(
            // @ts-expect-error ts-migrate(6133) FIXME: 'result' is declared but its value is never read.
            function (result) {
                // console.log(result)
            }, 
            // @ts-expect-error ts-migrate(6133) FIXME: 'err' is declared but its value is never read.
            function (err) {
                // console.error(err)
            });
        }
    };
    ShellLayoutComponent.prototype.onConfirmationModalInitialized = function (confirmationModal) {
        this.confirmationService.initialize(confirmationModal);
    };
    ShellLayoutComponent.prototype.detectIE = function () {
        var ua = window.navigator.userAgent;
        // Test values; Uncomment to check result …
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // IE 12 / Spartan
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // Edge (IE 12+)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
        // Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        // other browser
        return false;
    };
    ShellLayoutComponent.prototype.ngOnDestroy = function () {
        this.stageSubscription.unsubscribe();
    };
    return ShellLayoutComponent;
}());
export { ShellLayoutComponent };
